__webpack_require__.p = "/astrology/";